import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ToastContainer } from '@/components';
import './styles/globals.css';

async function main() {
  if (import.meta.env.VITE_USE_MOCKS === 'true') {
    let swReady = false;
    try {
      const { worker } = await import('./mocks/setup');
      // タイムアウト: SW が 3秒以内に起動しなければスキップしてアプリを描画
      const timeout = new Promise<'timeout'>((resolve) =>
        setTimeout(() => {
          console.warn('[MSW] Service Worker 起動タイムアウト');
          resolve('timeout');
        }, 3000),
      );
      const result = await Promise.race([
        worker.start({
          onUnhandledRequest: 'warn',
          serviceWorker: {
            url: `${import.meta.env.BASE_URL}mockServiceWorker.js`,
          },
        }).then(() => 'ready' as const),
        timeout,
      ]);
      swReady = result === 'ready';
    } catch (e) {
      console.warn('[MSW] Service Worker の起動に失敗しました:', e);
    }

    if (!swReady) {
      // SW 未起動 → /api/* への fetch を完全ブロックして本番データを保護
      const _fetch = window.fetch.bind(window);
      window.fetch = (input, init) => {
        const url = typeof input === 'string' ? input
          : input instanceof URL ? input.href
          : (input as Request).url;
        if (url.startsWith('/api/') || url.includes('/api/')) {
          console.error('[Mock] SW未起動のため本番APIへのアクセスをブロック:', url);
          return Promise.resolve(
            new Response(
              JSON.stringify({ error: '[Mock] Service Worker が起動していないためAPIへのアクセスはブロックされています。ページを再読み込みしてください。' }),
              { status: 503, headers: { 'Content-Type': 'application/json' } },
            ),
          );
        }
        return _fetch(input, init);
      };
      console.warn('[MSW] SW未起動: /api/* へのアクセスをブロックしました（本番データ保護）');
    }
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
      <ToastContainer />
    </StrictMode>,
  );
}

main();
